module.exports = __webpack_public_path__ + "media/images/sandbox/rondell/rondell-3-bd79a97e9efda49e53d2ea5ce7285c84.jpg";